import React from 'react';
import pt from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getStats, } from '../components/Stats/actions';
import StatsOffice from '../components/StatsOffice/StatsOffice';


// document.title = 'Statistiky';

const StatsOfficePage = ({
  params: { officeId, },
  statsData,
  getStats,
}) => {
  return (
    <StatsOffice
      key={officeId}
      officeId={officeId}
      statsData={statsData}
      getStats={getStats}
    />
  );
}


const mapStateToProps = (state) => {
  const { stats, } = state;
  return { 
    statsData: stats.statsData,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getStats: bindActionCreators(getStats, dispatch),
  };
}


StatsOfficePage.propTypes = {
  params: pt.shape({
    officeId: pt.string.isRequired,
  }).isRequired,
  statsData: pt.object.isRequired,
  getStats: pt.func.isRequired,
}


export default connect(mapStateToProps, mapDispatchToProps)(StatsOfficePage);



// WEBPACK FOOTER //
// ./src/pages/StatsOfficePage.js